import { BookOpen, LifeBuoy, Mail, MessageCircle } from "lucide-react";

const WHATSAPP_URL = "https://wa.me/966553691551";
const SUPPORT_EMAIL = "rasedhudury@gmail.com";
const GUIDE_URL = "/manager-guide.pdf";

export default function SupportTab() {
  return (
    <div className="bg-white rounded-2xl border shadow-sm p-6 sm:p-8" dir="rtl" data-testid="support-tab">
      <div className="flex items-center gap-3 mb-2">
        <LifeBuoy className="w-6 h-6 text-emerald-900" />
        <h2 className="text-xl font-bold text-emerald-950">الدعم والتواصل</h2>
      </div>
      <p className="text-sm text-slate-500 mb-8">فريق دعم متخصص يفهم طبيعة العمل الإداري المدرسي — نخدمك طوال العام الدراسي.</p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 max-w-3xl">
        <a href={WHATSAPP_URL} target="_blank" rel="noreferrer" data-testid="support-whatsapp-btn"
          className="bg-[#F0FDF4] border border-green-200 rounded-2xl p-6 hover:shadow-lg hover:-translate-y-1 transition-all duration-300 block">
          <MessageCircle className="w-7 h-7 text-green-600 mb-3" />
          <h3 className="font-bold text-emerald-950 mb-1">تواصل عبر واتساب</h3>
          <p className="text-xs text-slate-500 mt-1">يفتح محادثة واتساب مباشرة مع فريق الدعم — استجابة أسرع</p>
        </a>
        <a href={`mailto:${SUPPORT_EMAIL}`} data-testid="support-email-btn"
          className="bg-[#F8FAF9] border rounded-2xl p-6 hover:shadow-lg hover:-translate-y-1 transition-all duration-300 block">
          <Mail className="w-7 h-7 text-emerald-900 mb-3" />
          <h3 className="font-bold text-emerald-950 mb-1">إيميل الدعم</h3>
          <p dir="ltr" className="text-sm font-bold text-emerald-800 text-right">{SUPPORT_EMAIL}</p>
          <p className="text-xs text-slate-500 mt-1">للاستفسارات الفنية والاشتراكات</p>
        </a>
        <a href={GUIDE_URL} target="_blank" rel="noreferrer" download data-testid="support-guide-btn"
          className="bg-amber-50 border border-amber-200 rounded-2xl p-6 hover:shadow-lg hover:-translate-y-1 transition-all duration-300 block md:col-span-2">
          <BookOpen className="w-7 h-7 text-amber-600 mb-3" />
          <h3 className="font-bold text-emerald-950 mb-1">دليل المدير الإرشادي (PDF)</h3>
          <p className="text-xs text-slate-500 mt-1">دليل مصوّر يشرح جميع مزايا المنصة خطوة بخطوة — حمّله واطبعه أو شاركه مع وكلائك</p>
        </a>
      </div>

      <div className="mt-8 bg-emerald-50/60 border border-emerald-100 rounded-xl p-4 max-w-3xl">
        <p className="text-xs text-emerald-900 leading-6">
          عند التواصل يُفضّل ذكر بريد حسابك في المنصة ووصف مختصر للمشكلة أو الطلب لتسريع المعالجة.
        </p>
      </div>
    </div>
  );
}
